<template>
  <div>
    <!-- Page header -->
    <CCard class="mb-4">
      <CCardBody class="p-4">
        <CButton color="link" class="px-0 mb-2" @click="cancel">
          <CIcon name="cil-arrow-left" /> Products and services
        </CButton>
        <h1 class="h4 mb-1 font-weight-bold">{{ pageTitle }}</h1>
        <p class="text-muted mb-0">Something you sell, shown on quotations and invoices</p>
      </CCardBody>
    </CCard>

    <!-- Load failed -->
    <CCard v-if="loadError">
      <CCardBody class="text-center py-5">
        <CIcon name="cil-warning" size="2xl" class="text-danger mb-3" />
        <h2 class="h5">Couldn't load this product</h2>
        <p class="text-muted mb-3">Check your connection and try again.</p>
        <CButton color="primary" @click="resetObj">
          <CIcon name="cil-reload" /> Try again
        </CButton>
      </CCardBody>
    </CCard>

    <CCard v-else>
      <CCardBody>
        <div v-if="loading" class="text-center py-5">
          <div class="spinner-border text-primary" role="status">
            <span class="sr-only">Loading</span>
          </div>
          <p class="mt-3 text-muted mb-0">Loading product…</p>
        </div>
        <CRow v-else form>
          <CCol md="8">
            <CInput
              ref="nameInput"
              label="Name *"
              v-model="obj.name"
              placeholder="e.g. Website design"
              :is-valid="nameValid"
              invalid-feedback="Enter the product or service name"
              @blur="touched.name = true"
            />
            <CTextarea label="Description" rows="5" v-model="obj.description" />
          </CCol>
        </CRow>
      </CCardBody>
      <CCardFooter class="d-flex justify-content-between">
        <CButton color="light" :disabled="saving" @click="cancel">Cancel</CButton>
        <CButton color="primary" :disabled="saving || loading" @click="submit">
          <span v-if="saving" class="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>
          {{ isEdit ? "Save" : "Add product" }}
        </CButton>
      </CCardFooter>
    </CCard>
  </div>
</template>

<script>
import ProductApi from "@/lib/productApi";

export default {
  name: "Product",
  data: () => {
    return {
      selectedChartOfAccount: null,
      obj: {},
      loading: false,
      loadError: false,
      saving: false,
      submitted: false,
      touched: { name: false },
      api: new ProductApi(),
    };
  },
  mounted() {
    this.resetObj();
  },
  computed: {
    isEdit() {
      return !!this.$route.params.id;
    },
    pageTitle() {
      if (!this.isEdit) return "Add product";
      return this.obj.name || "Product";
    },
    nameValid() {
      if (!this.touched.name && !this.submitted) return null;
      return !!(this.obj.name && String(this.obj.name).trim()) || false;
    },
  },
  methods: {
    cancel() {
      this.$router.push({ path: "/tenants/ProductList" });
    },
    resetObj() {
      var self = this;
      self.loadError = false;
      if (self.$route.params.id) {
        self.loading = true;
        self.api
          .get(self.$route.params.id)
          .then((response) => {
            self.obj = response.result || {};
            self.selectedChartOfAccount = self.obj.chartAccount;
            self.loading = false;
          })
          .catch((err) => {
            console.error("Load product failed", err);
            self.loading = false;
            self.loadError = true;
          });
      } else {
        self.obj = self.getEmptyObj();
      }
    },
    onSubmit() {
      var self = this;
      if (self.selectedChartOfAccount) {
        self.obj.chartAccount = self.selectedChartOfAccount;
        self.obj.chartAccountId = self.selectedChartOfAccount.id;
      }
      const creating = !self.obj.id;
      const request = creating ? self.api.create(self.obj) : self.api.update(self.obj);
      self.saving = true;
      request
        .then(() => {
          self.saving = false;
          self.$toast.success(creating ? "Product added" : "Product saved");
          self.$router.push({ path: "/tenants/ProductList" });
        })
        .catch(({ data } = {}) => {
          self.saving = false;
          self.$toast.error(
            "Couldn't save the product. " + helper.getErrorMessage(data, "Please try again.")
          );
        });
    },
    getEmptyObj() {
      return {};
    },
    submit() {
      this.submitted = true;
      if (!this.nameValid) {
        this.$nextTick(() => {
          const input = this.$refs.nameInput && this.$refs.nameInput.$el.querySelector("input");
          if (input) input.focus();
        });
        return;
      }
      this.onSubmit();
    },
  },
};
</script>
